import { ORG_SMS_PROVIDERS } from 'src/constants/misc';

export const ORG_PHONE_PURPOSE_CODES = {
  SMS_TEXT_PURPOSE_CODE: 'sms_text',
  SMS_SURVEY_PURPOSE_CODE: 'sms_survey',
  DIRECT_SND_SMS_PURPOSE_CODE: 'direct_snd_sms',
};

export const SMS_PROVIDER_PURPOSE_CODE_MAP = {
  [ORG_SMS_PROVIDERS.DIRECT_SND]: ORG_PHONE_PURPOSE_CODES.DIRECT_SND_SMS_PURPOSE_CODE,
  [ORG_SMS_PROVIDERS.TWILIO]: ORG_PHONE_PURPOSE_CODES.SMS_TEXT_PURPOSE_CODE,
};

// Orgs that also use Twilio (sms_text) numbers for texting tasks & manual batches,
// in addition to the default direct_snd_sms numbers.
// payment method check is also waivered for these orgs.
export const TWILIO_SMS_SENDER_ORG_IDS = [8086];

// Purpose codes shown in the texting-sender dropdown for a given org.
export const getTextingSenderPurposeCodes = (organizationId) => {
  const codes = [ORG_PHONE_PURPOSE_CODES.DIRECT_SND_SMS_PURPOSE_CODE];
  if (TWILIO_SMS_SENDER_ORG_IDS.includes(Number(organizationId))) {
    codes.push(ORG_PHONE_PURPOSE_CODES.SMS_TEXT_PURPOSE_CODE);
  }
  return codes;
};

// Determines which SMS provider to send through for a given org + selected
// from-number. Twilio is only used for orgs in TWILIO_SMS_SENDER_ORG_IDS when a
// Twilio (sms_text) number is selected; everything else uses Direct SND.
export const getSmsProviderForSend = (organizationId, purposeCode) => {
  if (
    TWILIO_SMS_SENDER_ORG_IDS.includes(Number(organizationId)) &&
    purposeCode === ORG_PHONE_PURPOSE_CODES.SMS_TEXT_PURPOSE_CODE
  ) {
    return ORG_SMS_PROVIDERS.TWILIO;
  }
  return ORG_SMS_PROVIDERS.DIRECT_SND;
};
